$shm_hitalama_duckdb_page $mol_book2
	- current? *
		file_name \
		query \
	query_current? \
	remote_file_urls /
		<= remote_url \https://hitalama.github.io/hitalama-mol/shm/hitalama/duckdb/demo/parquet/demo.parquet
	pages /
		<= Query_page $mol_page
			title \DuckDB
			body /
				<= Project_and_files $mol_view
					sub /
						<= Project_label $mol_labeler
							title \Выберите проект
							content /
								<= Project $mol_select
									value? <=> project_id? \
									dictionary <= projects_dict *
						^ files_label / <= Files_label $mol_labeler
							title \Выберите файлы
							content /
								<= Files_scroll $mol_scroll
									sub /
										<= Files_list $mol_list
											sub <= file_views /
												<= File*0 $mol_view
													sub /
														<= File_check* $mol_check_box
															title <= file_name* \
															checked? <=> file_checked*? true
														<= File_name_copy* $shm_button_copy
															title <= query_default*? \
															button_sub / <= Copy_icon* $mol_icon_clipboard_outline
						- <= Files $mol_pick
							align \bottom_right
							trigger_content /
								\Выберите файлы
							bubble_content /
				<= Query_label $mol_labeler
					title \SQL-запрос
					content /
						<= Query $mol_textarea
							value? <=> query? \
							hint \
				<= Run $mol_button_minor
					title \Выполнить
					click? <=> run? null
				<= Duckdb_dump $mol_dump_value
					value <= duckdb_res? null
		<= Logs $mol_page
			title \Лог запросов
			tools /
				<= Logs_project $mol_select
					value? <=> logs_project_id? \
					dictionary <= projects_dict
				<= Logs_clear $mol_button_minor
					title \Очистить
					click? <=> logs_clear? null
			body <= logs /
				<= Query_log*0 $mol_view
					sub /
						<= Query_head* $mol_view
							sub /
								<= Query_time* $mol_paragraph
									title <= query_time* \
								<= Query_copy* $shm_button_copy
									minimal_height 24
									text <= query_sql* \
						<= Log_sql* $mol_text_code
							text <= query_sql* \
